import { Form as FormikForm } from 'formik'
import React from 'react'

export const Form = React.forwardRef<
  HTMLFormElement,
  React.ComponentPropsWithoutRef<typeof FormikForm>
>((props, ref) => <FormikForm {...props} ref={ref} data-hs-do-not-collect='true' />)
